/* eslint-disable max-lines */
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import RateReviewIcon from '@mui/icons-material/RateReview';
import React, { useState } from 'react';

import { updateInterviewStatus } from '../../../services/interviews';
import Modal from '../../global/components/Modal/Modal';
import BaseContactCard from '../../global/layouts/ContactCard/ContactCard';
import FeedbackModal from '../Interview/FeedbackModal';

import ProfileModal from './ProfileModal';

export default function ContactCard(props: {
    contact: {
        firstName: string;
        lastName: string;
        currentJobTitle: string;
        profilePicturePath: string;
        interviews: { id: number; companyID: number }[];
        userID: string;
        participantID: number;
    };
    uid: number;
    userID: string;
    role: 'candidate' | 'business';
    status: 'contacts' | 'pending' | 'declined';
    interviewIDs: number[];
}) {
    const [modal, setModal] = useState<
        'profile' | 'addcontact' | 'removecontact' | 'providefeedback' | ''
    >('');

    const actions = {
        viewProfile: {
            text: 'View Profile',
            onClick: () => setModal('profile'),
            icon: <PersonIcon fontSize={'small'} />
        },
        viewCompany: {
            text: 'View Company',
            to: `/secure/${props.userID}/company/${props.contact.interviews[0].companyID}`,
            icon: <BusinessIcon fontSize={'small'} />
        },
        removeContact: {
            text: 'Remove Contact',
            onClick: () => setModal('removecontact'),
            icon: null
        },
        addContact: {
            text: 'Add Contact',
            onClick: () => setModal('addcontact'),
            icon: <PersonAddAlt1Icon fontSize={'small'} />
        },
        provideFeedback: {
            text: 'Provide Feedback',
            onClick: () => setModal('providefeedback'),
            icon: <RateReviewIcon fontSize={'small'} />
        }
    } as {
        [key: string]: {
            text: string;
            onClick?: () => void;
            to?: string;
            icon: any;
        };
    };

    const modalActions = {
        addcontact: {
            title: 'Add Contact?',
            content: 'Adding to your contacts will allow you to chat and more.',
            action: () => {
                updateInterviewStatus(
                    props.contact.interviews[0].id,
                    'completed_network_accepted'
                ).then(() => setModal(''));
            }
        },
        removecontact: {
            title: 'Remove Contact?',
            content:
                'Removing contact will prevent you from chatting and more.',
            action: () => {
                updateInterviewStatus(
                    props.contact.interviews[0].id,
                    'completed_network_declined'
                ).then(() => setModal(''));
            }
        }
    };

    const actionMap = {
        candidate: {
            contacts: {
                actions: [actions.viewCompany],
                more: [actions.removeContact]
            },
            pending: { actions: [], more: [] },
            declined: { actions: [], more: [] }
        },
        business: {
            contacts: {
                actions: [actions.viewProfile],
                more: [actions.removeContact]
            },
            pending: {
                actions: [actions.addContact, actions.provideFeedback],
                more: [actions.viewProfile, actions.removeContact]
            },
            declined: {
                actions: [actions.addContact, actions.provideFeedback],
                more: [actions.viewProfile]
            }
        }
    };

    return (
        <>
            <BaseContactCard
                name={`${props.contact.firstName} ${props.contact.lastName}`}
                jobTitle={`${props.contact.currentJobTitle}`}
                imageURL={props.contact.profilePicturePath}
                actions={actionMap[props.role][props.status].actions}
                drawerActions={actionMap[props.role][props.status].more}
            />
            {modal === 'profile' && (
                <ProfileModal
                    open={modal === 'profile'}
                    handleClose={() => setModal('')}
                    connection={props.contact}
                    interviewIDs={props.interviewIDs}
                />
            )}
            {modal === 'providefeedback' && (
                <FeedbackModal
                    open={modal === 'providefeedback'}
                    onClose={() => setModal('')}
                    firstName={props.contact.firstName}
                    imageURL={props.contact.profilePicturePath}
                    interviewID={props.contact.interviews[0].id}
                    setCompletionPercent={() => {}}
                />
            )}
            {modal && modal !== 'profile' && modal !== 'providefeedback' && (
                <Modal
                    heading={modalActions[modal].title}
                    content={modalActions[modal].content}
                    open={!!modal}
                    onClose={() => setModal('')}
                    primaryCTAContent={'Submit'}
                    primaryCTAAction={modalActions[modal].action}
                />
            )}
        </>
    );
}
